import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfigState, AppConfigStore } from './app-config.store';
import { transaction, withTransaction } from '@datorama/akita';
import { DOCUMENT } from '@angular/common';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private appConfigStore: AppConfigStore,
        private http: HttpClient
    ) {}

    @transaction()
    get() {
        this.appConfigStore.setLoading(true);
        // check if config is available on window...
        if (this.document?.defaultView['sbEnv']) {
            return of(<AppConfigState>this.document.defaultView['sbEnv']).pipe(
                withTransaction((_) => {
                    this.appConfigStore.update(this.document.defaultView['sbEnv']);
                    this.appConfigStore.setLoading(false);
                })
            );
        }
        return this.http.get<AppConfigState>('assets/config/appconfig.json').pipe(
            withTransaction((config) => {
                // transform config string values to boolean
                this.appConfigStore.update(transformBooleanStrings(config));
                this.appConfigStore.setLoading(false);
            })
        );
    }
}

function transformBooleanStrings(config: AppConfigState): AppConfigState {
    const transformedConfig = {};
    for (const key in config) {
        if (config.hasOwnProperty(key)) {
            const value = config[key];
            if (typeof value === 'string' && (value === 'true' || value === 'false')) {
                transformedConfig[key] = value === 'true';
            } else {
                transformedConfig[key] = value;
            }
        }
    }

    return transformedConfig as AppConfigState;
}
